import React, { Fragment } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

import {
  Box,
  Grid,
  Card,
  CardContent,
  colors,
  Icon,
  Typography,
  Button,
  makeStyles
} from '@material-ui/core';

import EqualizerIcon from '@material-ui/icons/Equalizer';
import HistoryIcon from '@material-ui/icons/History';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { AiFillApi } from "react-icons/ai";
import { MdOutlineVideoLibrary } from "react-icons/md";
import { MdManageAccounts } from "react-icons/md";
import { MdEngineering } from "react-icons/md";

const items = [
  {
    href: '/mon/locations',
    icon: AiFillApi,
    title: 'Ponto de Instalação',
    color: colors.teal['A400'],
    profile: 'MON'
  },
  {
    href: '/mon/alarms',
    icon: NotificationsActiveIcon,
    title: 'Central de Alarme',
    color: colors.teal['A400'],
    profile: 'MON'
  },
  {
    href: '/mon/history',
    icon: HistoryIcon,
    title: 'Histórico de Alarme',
    color: colors.teal['A400'],
    profile: 'MON'
  },
  {
    href: '/mon/dashboard',
    icon: EqualizerIcon,
    title: 'Relatório de Alarme',
    color: colors.teal['A400'],
    profile: 'MON'
  },

  {
    href: '/mon/locations',
    icon: AiFillApi,
    title: 'Ponto de Instalação',
    color: colors.teal['A400'],
    profile: 'MAN'
  },
  {
    href: '/mon/alarms',
    icon: NotificationsActiveIcon,
    title: 'Central de Alarme',
    color: colors.teal['A400'],
    profile: 'MAN'
  },
  {
    href: '/mon/history',
    icon: HistoryIcon,
    title: 'Histórico de Alarme',
    color: colors.teal['A400'],
    profile: 'MAN'
  },
  {
    href: '/mon/dashboard',
    icon: EqualizerIcon,
    title: 'Relatório de Alarme',
    color: colors.teal['A400'],
    profile: 'MAN'
  },
  {
    href: '/sup/main',
    icon: MdOutlineVideoLibrary,
    title: 'Assistência Técnica',
    color: colors.orange[400],
    profile: 'MAN'
  },

  {
    href: '/mon/locations',
    icon: AiFillApi,
    title: 'Ponto de Instalação',
    color: colors.teal['A400'],
    profile: 'ADM'
  },
  {
    href: '/mon/alarms',
    icon: NotificationsActiveIcon,
    title: 'Central de Alarme',
    color: colors.teal['A400'],
    profile: 'ADM'
  },
  {
    href: '/mon/history',
    icon: HistoryIcon,
    title: 'Histórico de Alarme',
    color: colors.teal['A400'],
    profile: 'ADM'
  },
  {
    href: '/mon/dashboard',
    icon: EqualizerIcon,
    title: 'Relatório de Alarme',
    color: colors.teal['A400'],
    profile: 'ADM'
  },
  {
    href: '/adm/main',
    icon: MdManageAccounts,
    title: 'Administração',
    color: colors.blue[400],
    profile: 'ADM'
  },
  {
    href: '/mon/locations',
    icon: AiFillApi,
    title: 'Ponto de Instalação',
    color: colors.teal['A400'],
    profile: 'ENG'
  },
  {
    href: '/mon/alarms',
    icon: NotificationsActiveIcon,
    title: 'Central de Alarme',
    color: colors.teal['A400'],
    profile: 'ENG'
  },
  {
    href: '/mon/history',
    icon: HistoryIcon,
    title: 'Histórico de Alarme',
    color: colors.teal['A400'],
    profile: 'ENG'
  },
  {
    href: '/mon/dashboard',
    icon: EqualizerIcon,
    title: 'Relatório de Alarme',
    color: colors.teal['A400'],
    profile: 'ENG'
  },
  {
    href: '/adm/main',
    icon: MdManageAccounts,
    title: 'Administração',
    color: colors.blue[400],
    profile: 'ENG'
  },
  {
    href: '/mon/locations',
    icon: AiFillApi,
    title: 'Ponto de Instalação',
    color: colors.teal['A400'],
    profile: 'AAD'
  },
  {
    href: '/mon/alarms',
    icon: NotificationsActiveIcon,
    title: 'Central de Alarme',
    color: colors.teal['A400'],
    profile: 'AAD'
  },
  {
    href: '/mon/history',
    icon: HistoryIcon,
    title: 'Histórico de Alarme',
    color: colors.teal['A400'],
    profile: 'AAD'
  },
  {
    href: '/mon/dashboard',
    icon: EqualizerIcon,
    title: 'Relatório de Alarme',
    color: colors.teal['A400'],
    profile: 'AAD'
  },
  {
    href: '/mgt/main',
    icon: MdEngineering,
    title: 'Manutenção',
    color: colors.cyan[400],
    profile: 'AAD'
  },

];

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    width: 120,
    height: 120
  },
  grid: {
    marginTop: 10
  },
  card: {
    height: 200,
    minWidth: 200
  },
  button: {
    fontWeight: theme.typography.fontWeightMedium,
    textTransform: 'none',
    width: '100%'
  }
}));

const Results = ({ className }) => {

  const classes = useStyles();

  return (
    <Fragment>
      <Box>
        <Grid container
          className={classes.grid}
          spacing={2}
          direction="row"
          justifyContent={(screen.width <= 480) ? "center" : "flex-start"}
        >

          {items.map((value) => (

            <Grid item key={value.href} hidden={localStorage.getItem('profile') != value.profile}  >

              <Button
                className={classes.button}
                component={RouterLink}
                to={value.href}
              >

                <Card className={classes.card}>

                  <CardContent>

                    <Box alignItems="center"
                      display="flex"
                      flexDirection="column"
                    >

                      {<Icon className={classes.avatar} component={value.icon} style={{ color: value.color }} ></Icon>}

                      <Typography align="center"
                        color="primary"
                        gutterBottom
                        variant="h4"
                      >
                        {value.title}
                      </Typography>
                    </Box>

                  </CardContent>

                </Card>

              </Button>

            </Grid>

          ))}

        </Grid>

      </Box>

    </Fragment >
  );
};

export default Results;